import Tool, { type ToolArgs } from '../../../tools/Tool';
import { isSelectionInList, inListOfType } from '../utils';
import ListDepthUtils from '../ListDepthUtils';

// Indent a list item.
class ToolIncreaseIndent extends Tool {
  static toolName = 'Increase indent';
  static iconClass = 'fa-regular fa-indent';

  static action({ editor }: ToolArgs): void {
    ListDepthUtils.increaseDepth(editor);
  }

  static isEnabled({ editor }: ToolArgs): boolean {
    return isSelectionInList(editor) && !inListOfType(editor, 'dl_list');
  }
}

export default ToolIncreaseIndent;
